import { motion } from 'framer-motion';

// Restrained editorial reveal: subtle rise + fade, fires once per element.
export const Reveal = ({ children, delay = 0, y = 26, className = '', testid }) => (
  <motion.div
    data-testid={testid}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export default Reveal;
